import React from "react";
import { notifyInfo, useApiAction } from "@redriver/cinnamon";
import { Button, Icon } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import { PermissionCheck } from "components/auth";
import { Actions, Targets } from "constants/permissions";
import BulkActionsModal from "components/modals/BulkActionsModal";
import { deleteContent, downloadSelection } from "./actions";
import MoveWorkspaceItems from "./MoveWorkspaceItems";
import { useDownloadStreaming } from "modules/files";
import { refreshWorkspaceDirectory } from "features/System/WorkspaceMenu/actions";
import moment from "moment";

const WorkspaceContentSelectionBar = ({
  directoryId,
  siteName,
  siteRootDirectoryId,
  selection,
  totalSelected,
  filters,
  canEditContent,
  reordering,
  onRefresh,
  onClearSelection,
}) => {
  const dispatch = useDispatch();

  const [download, beginDownload] = useApiAction(downloadSelection);

  // stays mounted whatever the selection, so clearing it mid-download doesn't strand the stream
  useDownloadStreaming(
    download,
    `${siteName} ${moment().local().format("DD-MM-YY HH-mm")}.zip`
  );

  if (totalSelected == 0 || reordering) return null;

  const submitParams = {
    selected: selection.selected,
    deselected: selection.deselected,
    allSelected: selection.allSelected,
    search: filters.search,
    directoryId,
  };

  return (
    <div className="selection-bar">
      <span className="selection-count">
        <span className="selection-count-badge">{totalSelected}</span>
        selected
      </span>
      <div className="selection-divider" />
      <Button
        className="selection-action"
        onClick={() => {
          const toastExpiry = 10000;
          dispatch(notifyInfo(`Downloading files`, { expiry: toastExpiry }));
          beginDownload({ directoryId, selection });
        }}
      >
        <Icon name="download" />
        Download
      </Button>
      {canEditContent && (
        <PermissionCheck action={Actions.Edit} target={Targets.File}>
          <MoveWorkspaceItems
            directoryId={directoryId}
            siteRootDirectoryId={siteRootDirectoryId}
            selection={{
              selected: selection.selected,
              deselected: selection.deselected,
              allSelected: selection.allSelected,
              search: filters.search,
            }}
            as={Button}
            className="selection-action"
            onClose={() => {
              onRefresh();
              // the destination is elsewhere in the tree, so its counts need pulling too
              dispatch(refreshWorkspaceDirectory(siteRootDirectoryId));
            }}
          >
            <Icon name="folder open outline" />
            Move
          </MoveWorkspaceItems>
          <BulkActionsModal
            actionName="delete"
            header="Delete"
            submitParams={submitParams}
            onRefresh={onRefresh}
            submitAction={deleteContent}
            totalSelected={totalSelected}
            as={Button}
            className="selection-action danger"
            entityName="item"
          >
            <Icon name="trash alternate outline" />
            Delete
          </BulkActionsModal>
        </PermissionCheck>
      )}
      <Button className="selection-clear" onClick={onClearSelection}>
        <Icon name="close" />
        Clear selection
      </Button>
    </div>
  );
};

export default WorkspaceContentSelectionBar;
